import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TooltipProvider } from "@vd/ui";
import { Toaster } from "../components/toast";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <TooltipProvider>
      <Outlet />
      <Toaster />
    </TooltipProvider>
  ),
  notFoundComponent: () => (
    <div className="flex h-full items-center justify-center p-8 text-center">
      <div>
        <p className="text-body font-medium">This page doesn't exist.</p>
        <a href="/companies" className="mt-2 inline-block text-body text-accent-ink hover:underline">
          Go to Companies
        </a>
      </div>
    </div>
  ),
});
